import { Extension } from '@tiptap/core';

export const BrLinebreaks = Extension.create({
  name: 'brLinebreaks',

  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => {
        const { state } = editor;
        const { $from } = state.selection;
        const parent = $from.parent;

        if (parent.isTextblock && parent.content.size === 0) {
          // Insert <br /> instead of creating a new paragraph
          return editor.commands.setHardBreak();
        }

        // Fallback → let StarterKit handle normal paragraph behavior
        return false;
      },
    };
  },
});
